import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import ReactPlayer from 'react-player';
import { Popover } from 'antd';
import { css } from '@emotion/core';
import IconSvg from '../../common/IconSvg';

@injectIntl
@inject('onboardingStore')
@observer
class NonApiLearnToUse extends React.Component {

  render() {
return (
  <div
    css={css`
  text-align:center;
  `}
  >
    <ReactPlayer
      url="https://vimeo.com/475869269/dac447b637"
      width={400}
      height={200}
      css={css`
      margin: 0 auto;
      padding: 10px;
      `}
      playing
    />
    <Popover
      content={<a>You need to download this extension in order to use the Non-Api flow that you have chosen for your account.</a>}
      title=''
      trigger="hover"
      placement="bottom"
    >
      <div
        href=""
        css={css`
              height: 35px;
            `}
      >
        <IconSvg type="chrome" height={60} />
        <a
          rel="noopener noreferrer"
          target="_blank"
          href="https://chrome.google.com/webstore/detail/triplemars-non-api-extens/cennieobnabhoapafpokpomamekiepgn"
          css={css`
              margin:auto;
              text-decoration: underline;
              font-size: 23px;
              margin-left: 5px;
              vertical-align: middle;
            `}
        >
          Download Extension!
        </a>
      </div>
    </Popover>

  </div>
)
  }
}

NonApiLearnToUse.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  onboardingStore: PropTypes.object
};

export default NonApiLearnToUse;
